<template>
  <div class="pagination">
    <nav :class="props.theme.nav">
      <ul
        v-show="props.showPagination"
        :class="props.theme.list"
      >
        <!--<li v-if="props.hasEdgeNav" class='pagination__item' @click="props.setFirstPage">
          <a v-bind="{...props.aProps,...props.firstPageProps}">{{props.texts.first}}</a>
        </li>

        <li v-if="props.hasChunksNav" class='pagination__item' @click="props.setPrevChunk">
          <a v-bind="{...props.aProps, ...props.prevChunkProps}">{{props.texts.prevChunk}}</a>
        </li>
-->
        <li
          class="pagination__item"
          @click="props.setPrevPage"
        >
          <a v-bind="{...props.aProps,...props.prevProps}">
            <img
              class="pagination__image-left"
              src="/static/icons/angle-right.svg"
            >
          </a>
        </li>

        <li
          v-for="page in props.pages"
          :key="page"
          class="pagination__item"
          v-on="props.pageEvents(page)"
        >
          <a
            v-bind="props.aProps"
            :class="props.theme.link"
          >
            {{ page }}
          </a>
        </li>

        <li
          class="pagination__item"
          @click="props.setNextPage"
        >
          <a v-bind="{...props.aProps, ...props.nextProps}">
            <img src="/static/icons/angle-right.svg">
          </a>
        </li>

        <!--<li v-if="props.hasChunksNav" class='pagination__item' @click="props.setNextChunk">
          <a v-bind="{...props.aProps, ...props.nextChunkProps}">
            <img class="pagination__image" src="/static/icons/angle-right.svg" />
          </a>
        </li>

        <li v-if="props.hasEdgeNav" class="pagination__item" @click="props.setLastPage">
          <a v-bind="{...props.aProps, ...props.lastPageProps}">
            <img class="pagination__image" src="/static/icons/angle-right.svg" />
          </a>
        </li>
-->
      </ul>
      <!--
      <p v-show="props.hasRecords" :class='props.theme.count'>{{props.count}}</p>
-->
    </nav>
  </div>
</template>

<script>
export default {
  name: 'PaginationView',
  props: {
    props: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss" src="@/assets/components/pagination/pagination.scss"></style>



// WEBPACK FOOTER //
// index.vue